import Entity from './Entity';

export default class Message extends Entity {
  static TYPE_MESSAGE = 'message';
  static TYPE_TERRAIN_REPORT = 'terrain_report';
  static TYPE_EMERGENCY = 'emergency';

  constructor(data) {
    super(data);

    this.attributeKeys = [
      'id',
      'from',
      'to',
      'title',
      'message',
      'actionUrl',
      'receivedDate',
      'read',
      'deleted',
      'type',
      'publisherId',
      'status',
    ];
  }

  getId() {
    return this.get('id');
  }

  getFrom() {
    return this.get('from');
  }

  getTo() {
    return this.get('to');
  }

  getTitle() {
    return this.get('title');
  }

  getMessage() {
    return this.get('message');
  }

  getActionUrl() {
    const url = new URL(this.get('actionUrl'));
    return url.pathname;
  }

  getReceivedDate() {
    return this.get('receivedDate');
  }

  getScheduledOnDate() {
    return this.get('scheduledOnDate');
  }

  getType() {
    return this.get('type');
  }
}
